// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__sVGz1","bigColWidth":"Table_bigColWidth__8KT08","biggerColWidth":"Table_biggerColWidth__X7nkw","row":"Table_row__27o7M","col":"Table_col__2xLo3"};